'use strict';

import React, { Component } from 'react';
import styles from './assets/indexResponse.module.css';
import LazyImage from '../../components/lazyImage.jsx';

const print = function (value) { };
class DDS_lanhupage_0 extends Component {
  state = {};
  setValue(val) { }
  componentDidMount() {



  };


  render() {
    return (
      <div className={`flex-col ${styles['indexResponse_box1']} indexResponse_indexResponse_box1__2ufYZ`}>
        <div className={`flex-col  ${styles['indexResponse_banner']} indexResponse_indexResponse_banner__1tOV8`} />
        <span className={`${styles['dv_country_item_title']}`}>为什么留学⻢来西亚?</span>

        <div className={`${styles['dv_mainbody_wrap_box']}`}>
          <div className={`${styles['img_single']}`}>
            <img
              className='border-radius'
              src={
                require('./assets/img/2.jpg')
              } />
          </div>
          <div className={`${styles['dv_cuoutnry_phy_title']}`}>东南亚领先的教育枢纽 / 世界级教育</div>
          <div className={`${styles['dv_juzi_wrap']}`}>
            根据2023年QS世界⼤学排名，⻢来亚⼤学提供全球公认的学位，跻⾝世界顶尖⼤学⾏列，
            共有13所⼤学跻⾝前600名。根据2022年QS世界⼤学学科排名，⻢来西亚有10所⼤学的学科
            跻⾝前50名。
          </div>

          <div className={`${styles['img_single']}`}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/3.jpg')
              } />
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/4.jpg')
              } />
          </div>


          <div className={`${styles['dv_cuoutnry_phy_title']}`}>经济实惠</div>

          <div className={`${styles['dv_juzi_wrap']}`}>
            ⻢来西亚在⾐⻝住⾏、旅⾏、交通和学费等许多⽅⾯都提供了可负担性。⻢来西亚的⽣活成
            本指数仅为42.47，位居全球最低之⼀，约每⽉⽣活费约为 400 - 700 美元。<br />
            吉隆坡被 QS 评为其中⼀个最经济实惠的学⽣城市。<strong>这主要是因为与澳⼤利亚、英国、新加
              坡和加拿⼤等国家相⽐，以当地货币计算的⽣活费和学费⾄少便宜⼀半，甚⾄三分之⼆。</strong>
          </div>

          <div className={`${styles['img_single']}`}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/5.jpg')
              } />
          </div>
          <div className={`${styles['dv_cuoutnry_phy_title']}`}>语⾔环境：英语和中⽂⼴泛使⽤</div>

          <div className={`${styles['dv_juzi_wrap']}`}>
            在⻢来西亚，英语被⼴泛使⽤，有助于国际学⽣适应并更好地融⼊当地社会。此外，中⽂也在社
            会各个层⾯得到普及，许多华⼈社区以及中国⽂化的影响都使得中⽂成为⼀种常⻅的语⾔。⽆论
            您是在⾸都吉隆坡的街头穿梭还是在乡村地区探索宁静，您都可以使⽤英语或中⽂与当地⼈或国
            际友⼈交流。<br />
            虽然⻢来西亚语是该国的官⽅语⾔，但英语作为第⼆语⾔在⻢来西亚被⼴泛使⽤。⼤学的⼤多数
            课程都⽤英语讲授，只讲英语就可以在⻢来西亚的城市地区⽣活。在校园内外交流⾮常容易，尤
            其是当您养成了⻢来西亚⼈的英语习惯之后，⽐如在句⼦结尾使⽤ "lah"！
          </div>
          <div className={`${styles['img_single']}`}>
            <LazyImage
              className='border-radius lazy'
              imgUrl={
                require('./assets/img/6.jpg')
              } />
          </div>
          <div className={`${styles['dv_cuoutnry_phy_title']}`}>多元⽂化社会以及美⻝天堂</div>

          <div className={`${styles['dv_juzi_wrap']}`}>
            ⻢来西亚以其友好的社会和亚洲多元化社会的⼤熔炉⽽闻名，使其成为美⻝天堂，也是少数⼏
            个全年拥有数百个庆祝活动和节⽇的国家之⼀。学⽣将获得与来⾃不同⽂化背景的⼈⼀起⼯
            作、交流和⽣活的全球视野。留学⻢来西亚，体验多元⽂化之美。最终培养出能够适应任何环
            境，并为其加⼊的任何组织贡献丰富经验的⼈才。<br />
            此外，在东⻢的沙巴州和沙捞越州，有⽆数的⼟著⺠族，他们拥有⾃⼰独特的语⾔、⽂化和遗
            产。与⻢来西亚不同⺠族的交流可以让您接触到各种⽣活⽅式、宗教和社区。
          </div>

          <div className={`${styles['dv_cuoutnry_phy_title']}`}>美丽的⾃然景观/旅游胜地</div>
          <div className={`${styles['dv_juzi_wrap']}`}>
            ⻢来西亚的地理环境多样，海岸线上有原始的海滩，⽣物多样性丰富的⾬林在⻢来西亚半岛
            和东⻢来西亚提供了许多值得探索的冒险机会。探索⻢来西亚美丽的岛屿，欣赏丰富多彩的
            珊瑚礁、⻥类和其他稀有的海洋⽣物。<br />
            ⻢来西亚以其 "真正的亚洲 "的⼝号⽽闻名，⻓期以来⼀直巩固着其作为世界顶级旅游⽬的地
            之⼀的声誉。作为⽣态旅游热点，⻢来西亚拥有全球约 20% 的动物物种以及四个联合国教科
            ⽂组织世界遗产。其中，京那巴鲁国家公园拥有东南亚最⾼的⼭脉之⼀（神⼭）。
          </div>
          <div className={`${styles['img_single']}`}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/7.jpg')
              } />
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/8.jpg')
              } />
          </div>
          <div className={`${styles['dv_cuoutnry_phy_title']}`}>安全与和平</div>
          <div className={`${styles['dv_juzi_wrap']}`}>
            ⻢来西亚是 25 个最和平国家之⼀，⽬前在经济与和平研究所（IEP）2020 年全球和平指数
            中排名第 20 位。⻢来西亚是东南亚最具活⼒的经济体之⼀，这是⼏⼗年⼯业增⻓和政治稳
            定的成果。多年来，⻢来西亚政府成功地实现了国家的发展和⼯业化。如今，⻢来西亚是⼀
            个充满⾃信和活⼒的实体，国内稳定、安全、⽇益繁荣，与邻国和平相处，所有这些都为成
            为⼀个⾼收⼊、以创新为基础的社会奠定了坚实的基础。
          </div>

          <div className={`${styles['dv_cuoutnry_phy_title']}`}>优越位置</div>
          <div className={`${styles['dv_juzi_wrap']}`}>
            ⻢来西亚地理位置优越，是亚洲的旅游热点。在学期假期，您可以轻松前往浮罗交怡和雷当
            等当地旅游（链接到可做的事情），或前往巴厘岛、普吉岛、甲⽶和河内等地区旅游。从吉
            隆坡⻜往巴厘岛仅需 3 ⼩时，⽽⻜往甲⽶仅需 1 ⼩时 30 分钟。<br />
            您可以快速、便宜地前往世界更远的地⽅。包括⾸尔在内的韩国 5 ⽇游最低只需 750 美
            元。东京回程 3 晚住宿 350 美元起。到印尼朋友家做客，同时享受巴厘岛的海滩？往返低
            ⾄ 30 美元！
          </div>
          <div className={`${styles['img_single']}`}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/9.jpg')
              } />
          </div>


        </div>


      </div >
    );
  }
}
export default DDS_lanhupage_0;
